import { Button } from '@cian/ui-kit/button';
import { Modal, ModalTitle } from '@cian/ui-kit/modal';
import { useToast } from '@cian/ui-kit/toast';
import { UIHeading3 } from '@cian/ui-kit/typography';
import { useState } from 'react';

import type { IRepresentativeRequestData } from 'shared/services/createRepresentativeRequest';

import { RequestForm } from './components/RequestForm';
import style from './style.css';

export interface IRepresentativeRequestProps {
  /** Отклоняется при ошибке отправки */
  onSubmit(data: IRepresentativeRequestData): Promise<void>;
}

/**
 * «Хотите стать официальным представителем?» — `add_bsc_card.tsx` монолита. В отличие от монолита попап
 * закрывается только после успешной отправки: при ошибке введённые данные остаются (решение пользователя)
 */
export const RepresentativeRequest = ({ onSubmit }: IRepresentativeRequestProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const toast = useToast();

  const handleSubmit = async (data: IRepresentativeRequestData) => {
    try {
      await onSubmit(data);
      toast.open({ type: 'success', text: 'Ваша заявка успешно отправлена' });
      setIsOpen(false);
    } catch {
      toast.open({ type: 'error', text: 'Не удалось отправить заявку, попробуйте еще раз.' });
    }
  };

  return (
    <div className={style['container']} data-name="RepresentativeRequest">
      <UIHeading3 as="div">
        Хотите стать официальным
        <br />
        представителем?
      </UIHeading3>
      <div>
        <Button theme="main_primary" size="XS" onClick={() => setIsOpen(true)}>
          Отправить заявку
        </Button>
      </div>
      {/* Форма размонтируется при закрытии — при повторном открытии поля пустые, как в монолите */}
      <Modal open={isOpen} onOpenChange={setIsOpen} size="S" header={<ModalTitle>Отправить заявку</ModalTitle>}>
        <RequestForm onSubmit={handleSubmit} />
      </Modal>
    </div>
  );
};
